import { FetchResult, encodeApiUrl, fetchNoToken } from "../../_shared/services/ChannelApi";

export const telemetryApi = {
  trackEvent: async (
    event: string,
    identity: string,
    tenantId: string,
    properties: object | undefined,
    userProperties?: object | undefined,
    isError?: boolean
  ): Promise<FetchResult<void>> => {
    const result = await fetchNoToken<FetchResult<void>>(encodeApiUrl`/global/v1/telemetry`, {
      method: "POST",
      body: JSON.stringify({
        event,
        identity,
        tenantId,
        properties,
        userProperties,
        isError,
      }),
    });
    return result;
  },
};
